import { ToastContainer } from "react-toastify";
import { Outlet } from "react-router-dom";
import { useT } from "../../stores/uiLang";
import { PE_T } from "../../i18n/peLesson";

export function LtiLayout() {
  // Run E2 J5: the toast region's screen-reader label follows the UI language.
  const t = useT(PE_T);
  return (
    <div className="min-h-screen">
      <ToastContainer aria-label={t.notificationsAria} />
      {/* Render child routes */}
      <main className="flex flex-row md:flex-col min-h-[500px] w-full">
        <Outlet />
      </main>
    </div>
  );
}
